module.exports = __webpack_public_path__ + "static/media/concernDetailTitle.04fd87a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/concernDetailTitle.png
// module id = 906
// module chunks = 0